import { Modal } from "react-bootstrap";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import { downloadLink } from "../../helpers/constFIles";

/* first letters of the first and last words of a name, for the avatar */
const initials = (name) => {
    if (!name) return "?";
    const parts = String(name).trim().split(/\s+/);
    const first = parts[0] ? parts[0][0] : "";
    const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
    return (first + last).toUpperCase();
};

const Fact = ({ icon, label, value }) => (
    <div className="wh-fact">
        <span className="wh-fact-icon">{icon}</span>
        <div className="wh-fact-text">
            <span className="wh-fact-label">{label}</span>
            <span className="wh-fact-value">{value || "--"}</span>
        </div>
    </div>
);

const SkillGroup = ({ icon, title, items, empty }) => (
    <div className="wh-skill-group">
        <h6 className="wh-skill-title">{icon}{title}</h6>
        {items && items.length > 0
            ? <div className="wh-pills">
                {items.map((label, i) => <span className="wh-pill" key={i}>{label}</span>)}
            </div>
            : <p className="wh-skill-empty">{empty}</p>}
    </div>
);

export default function EmpDetails({ show, data, hide }) {

    const skills = (data.skills || []).map((s) => s.name);
    const desired = data.desiredSkills || [];

    return (
        <Modal show={show} onHide={() => { hide() }} size="lg" className="wh-modal">
            <Modal.Header closeButton>
                <Modal.Title>Employee Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className="wh-profile-hero">
                    <div className="wh-avatar-stack">
                        <span className="wh-avatar">{initials(data.employeeName)}</span>
                        {data.profilePic && (
                            <img className="wh-avatar" src={downloadLink + data.profilePic}
                                alt=""
                                onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        )}
                    </div>
                    <div className="wh-profile-id">
                        <h5>{data.employeeName || "--"}</h5>
                        <p>{data.designation || "Designation not set"}</p>
                    </div>
                    <span className="wh-pill wh-profile-code">{data.employeeCode}</span>
                </div>

                <div className="wh-facts-grid">
                    <Fact icon={<AlternateEmailOutlinedIcon />} label="Email" value={data.emailID} />
                    <Fact icon={<PhoneInTalkOutlinedIcon />} label="Mobile" value={data.mobile} />
                    {/* <Fact icon={<BadgeOutlinedIcon />} label="Employee ID" value={data.employeeCode} /> */}
                    <Fact icon={<SupervisorAccountOutlinedIcon />} label="Reports To" value={data.managerName} />
                    <Fact icon={<ApartmentOutlinedIcon />} label="Department" value={data.department} />
                    <Fact icon={<WorkOutlineOutlinedIcon />} label="Designation" value={data.designation} />
                    <Fact icon={<TimelineOutlinedIcon />} label="Experience" value={data.experience} />
                </div>

                <div className="wh-skill-row">
                    <SkillGroup icon={<PsychologyOutlinedIcon />} title="Skills"
                        items={skills} empty="No skills entered yet" />
                    <SkillGroup icon={<AutoAwesomeOutlinedIcon />} title="Desired Skills"
                        items={desired} empty="No desired skills entered yet" />
                </div>

            </Modal.Body>
        </Modal>
    )
}
